import Box from '@mui/material/Box';
import { type ReactNode, useMemo } from 'react';
import { dateWindowFromRange } from '../../lib/dateUtils.js';
import { FILTER_BAR_ROW_SX } from '../filters/menuStyles.js';
import { ScopeLabel } from '../filters/ScopeLabel.js';
import { DateRangeControl, MultiScopeSelectControl } from '../filters/ScopeRow.js';
import type { ScopeState } from '../filters/types.js';
import { useScopeOptions } from '../filters/useScopeOptions.js';

const SCOPE_TITLE =
  'The accounts and reporting window an outcome was produced for — the scope its workflow ran with.';

export interface OutcomesScopeBarProps {
  scope: ScopeState;
  onChange: (scope: ScopeState) => void;
}

export function OutcomesScopeBar({ scope, onChange }: OutcomesScopeBarProps): ReactNode {
  const { brandOptions, platformOptions, accountOptions } = useScopeOptions(scope);
  const resolved = useMemo(() => dateWindowFromRange(scope.range, new Date()), [scope.range]);

  return (
    <Box sx={FILTER_BAR_ROW_SX}>
      <ScopeLabel title={SCOPE_TITLE} />
      <MultiScopeSelectControl
        label="Brand"
        showSingleOptionName
        placeholderLabel="All brands"
        options={brandOptions}
        selected={scope.brand}
        onChange={(brand) => onChange({ ...scope, brand })}
      />
      <MultiScopeSelectControl
        label="Platform"
        showSingleOptionName
        placeholderLabel="All platforms"
        options={platformOptions}
        selected={scope.platform}
        onChange={(platform) => onChange({ ...scope, platform })}
      />
      <MultiScopeSelectControl
        label="Ad Account"
        showSingleOptionName
        placeholderLabel="All ad accounts"
        options={accountOptions}
        selected={scope.account}
        onChange={(account) => onChange({ ...scope, account })}
      />
      <DateRangeControl
        value={scope.range}
        onChange={(range) => onChange({ ...scope, range })}
        resolved={resolved}
      />
    </Box>
  );
}
